import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { contact } from "../mock";

export default function FloatingButtons() {
  return (
    <div className="fixed right-5 bottom-6 z-40 flex flex-col gap-3">
      <a
        href={`tel:${contact.phone}`}
        className="w-12 h-12 rounded-full bg-orange-500 hover:bg-orange-600 text-white shadow-lg flex items-center justify-center transition-transform hover:scale-110"
        aria-label="Call us"
      >
        <Phone size={20} />
      </a>
      <a
        href={`https://wa.me/${contact.whatsapp}?text=Hello!%20I%20would%20like%20to%20inquire%20about%20your%20heating%20products.`}
        target="_blank"
        rel="noreferrer"
        className="w-12 h-12 rounded-full bg-green-500 hover:bg-green-600 text-white shadow-lg flex items-center justify-center transition-transform hover:scale-110"
        aria-label="WhatsApp"
      >
        <MessageCircle size={20} />
      </a>
    </div>
  );
}
